import React from "react";
import './ReportCardPrint.css';
import { numberToWords } from "../../../Utility/constants";

const headerStyle = {
    border: "1px solid black",
    padding: "6px",
    fontSize: "10px",
    textAlign: "center",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
    lineHeight: "14px"
};

const cellStyle = {
    border: "1px solid black",
    padding: "5px",
    fontSize: "11px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal"
};

const ReportCardTemplate = ({
    studentData,
    marksData,
    schoolData
}) => {

    return (
        <div
            className="report"
            style={{
                width: "100%",
                maxWidth: "100%",
                margin: "0 auto",
                padding: "10px",
                border: "1px solid black",
            }}
        >

            {/* TABLE 1 */}

            <table
                className="header-table"
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed"
                }}
            >
                <tbody>

                    <tr>

                        <td
                            style={{
                                width: "120px",
                                verticalAlign: "middle",
                                textAlign: "center",
                                padding: "5px"
                            }}
                        >
                            <img
                                src={schoolData?.logo}
                                alt="School Logo"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                    display: "block",
                                    margin: "0 auto"
                                }}
                            />
                        </td>

                        <td
                            style={{
                                borderRight: "none",
                                width: "calc(100% - 240px)",
                                textAlign: "center",
                                padding: "5px"
                            }}
                        >

                            <span style={{ fontSize: "14px" }}>
                                {schoolData?.organizationName}
                            </span>

                            <br />

                            <span
                                style={{
                                    fontSize: "18px",
                                }}
                            >
                                {schoolData?.schoolOrCollegeName}
                            </span>

                            <br />

                            <b>
                                (Affiliated to H.S.C. Board, Govt. Of Maharashtra)
                            </b>

                            <br />

                            Address : {schoolData?.address}

                            <br />

                            Phone No.
                            <b>{schoolData?.schoolOrCollegeContactNo}</b>

                            {" | "}

                            Website :
                            <b>{schoolData?.schoolWebsiteName}</b>

                            <br />

                            Email :
                            <b>{schoolData?.email}</b>

                            <br />

                            U-DISE No :
                            <b>{schoolData?.udiseNo}</b>

                            {" | "}

                            {(schoolData?.ssC10thIndexNo ||
                                schoolData?.hsC12thIndexNo) && (
                                    <>
                                        Index No :
                                        <b>
                                            {schoolData?.ssC10thIndexNo}

                                            {schoolData?.ssC10thIndexNo &&
                                                schoolData?.hsC12thIndexNo &&
                                                " | "}

                                            {schoolData?.hsC12thIndexNo}
                                        </b>
                                    </>
                                )}

                        </td>

                        <td
                            style={{
                                width: "120px",
                                borderLeft: "none"
                            }}
                        ></td>

                    </tr>

                </tbody>
            </table>

            <span
                style={{
                    fontWeight: "bold",
                    textAlign: "center",
                    display: "block",
                    marginTop: "20px",
                    marginBottom: "10px"
                }}
            >
                STATEMENT OF MARKS
            </span>

            {/* TABLE 2 */}

            <table
                className="title"
                style={{
                    border: "1px solid black",
                    width: "100%",
                    tableLayout: "fixed",
                    borderCollapse: "collapse"
                }}
            >

                <colgroup>
                    <col style={{ width: "22%" }} />
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "30%" }} />
                    <col style={{ width: "15%" }} />
                </colgroup>

                <thead>

                    <tr>

                        <th style={headerStyle}>
                            CLASS & STREAM
                        </th>

                        <th style={headerStyle}>
                            DIV.
                        </th>

                        <th style={headerStyle}>
                            ROLL NO.
                        </th>

                        <th style={headerStyle}>
                            ACADEMIC YEAR
                        </th>

                        <th style={headerStyle}>
                            MONTH & YEAR OF EXAM
                        </th>

                        <th style={headerStyle}>
                            ID NO.
                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr>

                        <td style={cellStyle}>
                            <strong>
                                {studentData?.standardName} - {studentData?.stream}
                            </strong>
                        </td>

                        <td style={cellStyle}>
                            <strong>{studentData?.divName}</strong>
                        </td>

                        <td style={cellStyle}>
                            <strong>{studentData?.rollNo}</strong>
                        </td>

                        <td style={cellStyle}>
                            <strong>{studentData?.sessionName}</strong>
                        </td>

                        <td style={cellStyle}>
                            <strong>
                                {/* {new Date().toLocaleString('default', {
                                    month: 'long'
                                })} */}
                                APR
                                {" - "}
                                {new Date().getFullYear()}
                            </strong>
                        </td>

                        <td style={cellStyle}>
                            <strong>{studentData?.generalRegisterNo}</strong>
                        </td>

                    </tr>

                    <tr>

                        <td
                            colSpan={6}
                            style={{
                                ...cellStyle,
                                textAlign: "left"
                            }}
                        >
                            <strong>CANDIDATE'S FULL Name :</strong>

                            {" "}

                            {studentData?.firstName?.trim()?.toUpperCase() || ""}
                            {" "}
                            {studentData?.middleName?.trim()?.toUpperCase() || ""}
                            {" "}
                            {studentData?.lastName?.trim()?.toUpperCase() || ""}

                            <br></br><br></br>
                            <strong>MOTHER'S NAME :</strong>

                            {" "}

                            {studentData?.motherName?.trim()?.toUpperCase() || ""}

                        </td>

                    </tr>

                </tbody>

            </table>

            {/* TABLE 3 */}

            <table
                className="marks-table"
                aria-label="Marks table"
                style={{
                    width: "100%",
                    tableLayout: "fixed",
                    borderCollapse: "collapse"
                }}
            >

                <colgroup>
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "18%" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "35%" }} />
                </colgroup>

                <thead>

                    <tr>

                        <th rowSpan="2" style={headerStyle}>
                            Subject Code
                        </th>

                        <th rowSpan="2" style={{ ...headerStyle, textAlign: "left" }}>
                            Subject Name
                        </th>

                        <th rowSpan="2" style={headerStyle}>
                            Maximum Marks
                        </th>

                        <th colSpan="2" style={headerStyle}>
                            Marks Obtained
                        </th>

                    </tr>

                    <tr>

                        <th style={headerStyle}>
                            In Figures
                        </th>

                        <th style={headerStyle}>
                            In Words
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {/* NON GRADE SUBJECTS */}

                    {marksData?.subjects
                        ?.filter(x => !x.isGrade)
                        .map((mark, index) => (

                            <tr key={index}>

                                <td style={{
                                    ...cellStyle,
                                    textAlign: "center",
                                }}>
                                    {mark?.subjectCode}
                                </td>

                                <td style={cellStyle}>
                                    {mark?.subjectName?.trim()?.toUpperCase() || ""}
                                </td>

                                <td
                                    style={{
                                        ...cellStyle,
                                        textAlign: "center"
                                    }}
                                >
                                    100
                                </td>

                                <td
                                    style={{
                                        ...cellStyle,
                                        textAlign: "center"
                                    }}
                                >
                                    {mark?.totalMarks}{mark?.graceMarks > 0 ? '*' : ''}
                                </td>

                                <td
                                    style={{
                                        ...cellStyle,
                                        fontSize: "10px",
                                        textAlign: "left"
                                    }}
                                >
                                    {numberToWords(mark?.totalMarks)?.toUpperCase() || ""}
                                    {mark?.graceMarks > 0 ? "*" : ""}
                                </td>

                            </tr>

                        ))}

                    {/* GRADE SUBJECTS */}

                    {marksData?.subjects
                        ?.filter(x => x.isGrade)
                        .map((mark, index) => (

                            <tr key={index}>

                                <td style={{ ...cellStyle, textAlign: "center" }}>
                                    {mark?.subjectCode}
                                </td>

                                <td style={cellStyle}>
                                    {mark?.subjectName?.trim()?.toUpperCase() }
                                </td>

                                <td
                                    colSpan={2}
                                    style={{
                                        ...cellStyle,
                                        textAlign: "center"
                                    }}
                                >
                                    {mark?.grade}
                                </td>

                                <td style={cellStyle}></td>

                            </tr>

                        ))}

                    {/* TOTAL */}

                    <tr>

                        <td
                            colSpan={2}
                            style={{
                                ...cellStyle,
                                textAlign: "center",
                                fontWeight: "bold"
                            }}
                        >
                            TOTAL MARKS
                        </td>

                        <td
                            style={{
                                ...cellStyle,
                                textAlign: "center",
                                fontWeight: "bold"
                            }}
                        >
                            600
                        </td>

                        <td
                            style={{
                                ...cellStyle,
                                textAlign: "center",
                                fontWeight: "bold"
                            }}
                        >
                            {marksData?.totalWithGrace}
                        </td>

                        <td
                            style={{
                                ...cellStyle,
                                fontSize: "10px",
                                textAlign: "center",
                                fontWeight: "bold"
                            }}
                        >
                            {numberToWords(marksData?.totalWithGrace)?.toUpperCase() || ""}
                        </td>

                    </tr>

                    {/* RESULT */}

                    <tr>

                        <td
                            colSpan={2}
                            style={{
                                ...cellStyle,
                                textAlign: "center"
                            }}
                        >
                            Result : {marksData?.remark}
                        </td>

                        <td
                            colSpan={2}
                            style={{
                                ...cellStyle,
                                textAlign: "center"
                            }}
                        >
                            Percentage : {marksData?.percentage}
                        </td>

                        <td
                            style={{
                                ...cellStyle,
                                textAlign: "center"
                            }}
                        >
                            Grade :
                            {marksData?.percentage >= 75 ? 'DISTINCTION'
                                : marksData?.percentage >= 60 && marksData?.percentage < 75 ? ' I'
                                    : marksData?.percentage >= 45 && marksData?.percentage < 60 ? ' II'
                                        : marksData?.percentage >= 35 && marksData?.percentage < 45 ? ' PASS'
                                            : (marksData?.percentage < 35 && marksData?.subjects?.some(x => x.isGrade)) ? ' PROMOTED'
                                                : (marksData?.percentage < 35 && !marksData?.subjects?.some(x => x.isGrade)) ? ' NA'
                                                    : ''
                            }
                        </td>

                    </tr>
                    {/* HEALTH EDUCATION */}
                    <tr>

                        <td
                            colSpan={5}
                            style={{
                                border: "1px solid black",
                                padding: "5px",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: "11px"
                            }}
                        >
                            GRADES IN THE HEALTH & PHYSICAL EDUCATION SUBJECT
                        </td>

                    </tr>

                    <tr>

                        {["GRADES", "A", "B", "C", "D"].map((item, i) => (
                            <td
                                key={i}
                                style={{
                                    border: "1px solid black",
                                    padding: "5px",
                                    textAlign: "center",
                                    fontSize: "10px",
                                    wordBreak: "break-word"
                                }}
                            >
                                {item}
                            </td>
                        ))}

                    </tr>

                    <tr>

                        <td style={{
                            border: "1px solid black",
                            padding: "5px",
                            textAlign: "center",
                            fontSize: "10px"
                        }}>
                            Marks Obtained
                        </td>

                        <td style={{
                            border: "1px solid black",
                            padding: "5px",
                            textAlign: "center",
                            fontSize: "10px"
                        }}>
                            60% & above
                        </td>

                        <td style={{
                            border: "1px solid black",
                            padding: "5px",
                            textAlign: "center",
                            fontSize: "10px"
                        }}>
                            45% to 59%
                        </td>

                        <td style={{
                            border: "1px solid black",
                            padding: "5px",
                            textAlign: "center",
                            fontSize: "10px"
                        }}>
                            35% to 44%
                        </td>

                        <td style={{
                            border: "1px solid black",
                            padding: "5px",
                            textAlign: "center",
                            fontSize: "10px"
                        }}>
                            34% and below
                        </td>

                    </tr>

                    {/* CERTIFICATE */}
                    <tr>

                        <td
                            colSpan={5}
                            style={{
                                border: "1px solid black",
                                padding: "5px",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: "11px"
                            }}
                        >
                            GRADES OF CERTIFICATE
                        </td>

                    </tr>

                    <tr>

                        {[
                            "GRADE-I WITH DISTINCTION",
                            "GRADE-I",
                            "GRADE-II",
                            "GRADE-PASS",
                            "PROMOTED"
                        ].map((item, i) => (
                            <td
                                key={i}
                                style={{
                                    border: "1px solid black",
                                    padding: "5px",
                                    textAlign: "center",
                                    fontSize: "10px",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word"
                                }}
                            >
                                {item}
                            </td>
                        ))}

                    </tr>

                    <tr>

                        {[
                            "75% AND ABOVE",
                            "60% AND ABOVE BUT BELOW 75%",
                            "45% AND ABOVE BUT BELOW 60%",
                            "ALL OTHER SUCCESSFULL CANDIDATES (INCLUDING THE EXCEPTION)",
                            "PROMOTED UNDER CONDONATION"
                        ].map((item, i) => (
                            <td
                                key={i}
                                style={{
                                    border: "1px solid black",
                                    padding: "5px",
                                    textAlign: "center",
                                    fontSize: "9px",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal"
                                }}
                            >
                                {item}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td
                            colSpan={5} style={{
                                height: "250px",
                                borderLeft: "1px solid black",
                                borderRight: "1px solid black",
                            }}>

                        </td>
                    </tr>

                    <tr>

                        <td
                            colSpan={3}
                            style={{
                                textAlign: "left",
                                height: "70px",
                                borderLeft: "1px solid black",
                                borderTop: "none",
                                paddingLeft: "50px"
                            }}
                        >
                            Vice Principal
                        </td>

                        <td
                            colSpan={2}
                            style={{
                                textAlign: "right",
                                height: "70px",
                                borderRight: "1px solid black",
                                borderTop: "none",
                                paddingRight: "50px"
                            }}
                        >
                            Principal
                        </td>

                    </tr>

                    <tr>

                        <td
                            colSpan={5}
                            style={{
                                textAlign: "left",
                                borderLeft: "1px solid black",
                                borderTop: "none",
                                borderRight: "1px solid black",
                            }}
                        >
                            Result Declaration Date : 01-May-{new Date().getFullYear()}
                        </td>

                    </tr>

                    <tr>

                        <td
                            colSpan={5}
                            style={{
                                textAlign: "left",
                                height: "100px",
                                borderLeft: "1px solid black",
                                borderTop: "none",
                                borderBottom: "1px solid black",
                                borderRight: "1px solid black",
                                borderWidth: "0px",
                                verticalAlign: "top",
                            }}
                        >
                            <span> Note : Minimum 35% marks are essential to pass in each Subject</span>

                            <br />

                            <span style={{ marginLeft: "36px" }}> No change in this Statement of Marks shall be made except by the authority issuing it.</span>

                            <br />

                            <span style={{ marginLeft: "36px" }}>Means gracing as per H.S.C. Board rules.</span>

                        </td>

                    </tr>



                </tbody>

            </table>

        </div>
    );
};

export default ReportCardTemplate;